import { RouteContext } from '@lobby/contexts/RouteContext';
import { useContext } from 'react';
import { BrowserRouter, useInRouterContext } from 'react-router';

import App from './App';

export const AppRouter = () => {
  const isInsideRouter = useInRouterContext();
  const { basename } = useContext(RouteContext);

  return isInsideRouter ? (
    <App />
  ) : (
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  );
};
